import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoRootModule } from '../transloco/transloco-root.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { PasswordModule } from 'primeng/password';
import { SliderModule } from 'primeng/slider';
import { TreeModule } from 'primeng/tree';
import { EditorModule } from '@tinymce/tinymce-angular';
import { CheckboxModule } from 'primeng/checkbox';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { InputNumberModule } from 'primeng/inputnumber';
import { RadioButtonModule } from 'primeng/radiobutton';
import { FileUploadModule } from 'primeng/fileupload';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { ToastModule } from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { TooltipModule } from 'primeng/tooltip';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';

import { FormControlComponent } from './form-control/form-control.component';
import { FormErrorComponent } from './form-error/form-error.component';
import { LoaderComponent } from './loader/loader.component';
import { FormButtonsComponent } from './form-buttons/form-buttons.component';
import { PillNavComponent } from './pill-nav/pill-nav.component';
import { ModalSpinnerComponent } from './modal-spinner/modal-spinner.component';
import { DetailViewComponent } from './detail-view/detail-view.component';
import { ListViewComponent } from './list-view/list-view.component';
import { EmployeeSearchComponent } from './employee-search/employee-search.component';
import { CoreModule } from 'projects/core/src/public-api';
import { ChipsModule } from 'primeng/chips';

@NgModule({
  declarations: [
    DetailViewComponent,
    EmployeeSearchComponent,
    FormControlComponent,
    FormErrorComponent,
    FormButtonsComponent,
    ListViewComponent,
    LoaderComponent,
    ModalSpinnerComponent,
    PillNavComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslocoRootModule,
    CoreModule,
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
    MultiSelectModule,
    PasswordModule,
    SliderModule,
    ProgressSpinnerModule,
    TableModule,
    DialogModule,
    DropdownModule,
    TreeModule,
    EditorModule,
    CheckboxModule,
    CascadeSelectModule,
    InputNumberModule,
    RadioButtonModule,
    FileUploadModule,
    ToastModule,
    MessagesModule,
    MessageModule,
    TooltipModule,
    CalendarModule,
    ChipsModule
  ],
  exports: [
    DetailViewComponent,
    EmployeeSearchComponent,
    FormControlComponent,
    FormErrorComponent,
    FormButtonsComponent,
    ListViewComponent,
    LoaderComponent,
    ModalSpinnerComponent,
    PillNavComponent
  ]
})
export class SharedModule { }
